import { render, staticRenderFns } from "./app-mero-place.vue?vue&type=template&id=c88260c8&"
import script from "./app-mero-place.vue?vue&type=script&lang=js&"
export * from "./app-mero-place.vue?vue&type=script&lang=js&"
import style0 from "./app-mero-place.vue?vue&type=style&index=0&id=c88260c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports